var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowerSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.5,
    height: 110.726,
    viewBox: "0 0 101.5 110.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grower",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M85.923,33.218v.009a7.377,7.377,0,1,1,0,14.754A20.3,20.3,0,0,1,74.85,66.039V74.3a37.681,37.681,0,0,1,3.691.788V92.272H52.7V75.089c1.205-.327,2.44-.58,3.691-.788V66.039A20.3,20.3,0,0,1,45.323,47.982a7.378,7.378,0,1,1,0-14.756v-.008a20.269,20.269,0,0,1,.353-3.691h-22.5a1.845,1.845,0,0,1-.91-3.451l7.6-4.313A97.705,97.705,0,0,0,44,11.848,12.886,12.886,0,0,0,34.25,7.382a1.845,1.845,0,0,1,0-3.691A16.56,16.56,0,0,1,46.809,9.462c1.567-1.358,3.167-2.787,4.841-4.344A20.618,20.618,0,0,1,65.623,0,20.622,20.622,0,0,1,79.6,5.117c8.192,7.616,14.909,12.748,21.776,16.646l7.6,4.313a1.845,1.845,0,0,1-.91,3.451h-22.5A20.422,20.422,0,0,1,85.923,33.218Zm0,11.073a3.691,3.691,0,1,0,0-7.382Zm-40.6-7.382a3.691,3.691,0,1,0,0,7.382Zm14.764,38.97v3.475a5.536,5.536,0,0,0,11.073,0V67.51c-.113.033-.232.042-.347.074a20.368,20.368,0,0,1-2.023.425c-.207.033-.412.068-.62.1a18.385,18.385,0,0,1-5.092,0c-.208-.028-.413-.063-.622-.1a20.33,20.33,0,0,1-2.023-.425c-.114-.031-.232-.041-.347-.074v8.369Zm40.989-50.043-1.521-.864C92.426,20.929,85.5,15.64,77.085,7.821a16.906,16.906,0,0,0-11.462-4.13,16.909,16.909,0,0,0-11.462,4.13c-1.814,1.687-3.551,3.237-5.245,4.7A16.505,16.505,0,0,1,50.86,20.3a1.845,1.845,0,1,1-3.691,0,12.844,12.844,0,0,0-1.161-5.324,100.613,100.613,0,0,1-14.315,10l-1.523.864h70.905Z",
    transform: "translate(-8.414 0)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M373.047,238.931a1.845,1.845,0,0,1,1.845,1.845V255.54a9.186,9.186,0,0,0,3.669,7.317l.022-20.237a1.846,1.846,0,0,1,1.845-1.844h0a1.844,1.844,0,0,1,1.844,1.847l-.024,21.952a9.212,9.212,0,0,0,3.715.006l.024-21.961a1.846,1.846,0,0,1,1.845-1.844h0a1.845,1.845,0,0,1,1.844,1.847l-.022,20.25a9.193,9.193,0,0,0,3.689-7.334V240.776a1.845,1.845,0,1,1,3.691,0V255.54a12.929,12.929,0,0,1-11.073,12.771V296.14a1.845,1.845,0,0,1-3.691,0V268.31A12.928,12.928,0,0,1,371.2,255.54V240.776A1.845,1.845,0,0,1,373.047,238.931Z",
    transform: "translate(-371.201 -187.259)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M177.708,458.494H140.8V443.73h36.909Zm-7.38-11.073-22.145-.024h0a1.845,1.845,0,0,0,0,3.691l22.145.024h0a1.845,1.845,0,0,0,0-3.691Z",
    transform: "translate(-102.044 -347.768)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M46.932,352.789a35,35,0,0,1,22.145,32.585,1.844,1.844,0,0,1-1.845,1.845H52.468V370.61a1.845,1.845,0,0,0-1.845-1.845H46.932Z",
    transform: "translate(26.886 -276.494)",
    fill: "#007cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M325.077,352.789v15.976h-3.691a1.845,1.845,0,0,0-1.845,1.845v16.609H304.777a1.844,1.844,0,0,1-1.845-1.845A34.995,34.995,0,0,1,325.077,352.789Z",
    transform: "translate(-284.477 -276.494)",
    fill: "#007cab"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowerSelected);
export default __webpack_public_path__ + "static/media/Grower_Selected.b11b04dae640b3a8b143caff86347043.svg";
export { ForwardRef as ReactComponent };